import { CHECKOUT_MODE_PARAM, CheckoutMode } from '@/constants/checkoutMode';
import type { CheckoutConfigurations } from '@/types/checkout';
import { getCheckoutSolution } from '@/utils/checkoutSolution';
import { getQueryParam } from '@/utils/queryParams';

/**
 * Whether the store opened the checkout as a full-page navigation (`?mode=redirect`)
 * rather than as an iframe overlay.
 */
export const isRedirectModeRequested = () =>
  getQueryParam(CHECKOUT_MODE_PARAM).trim().toLowerCase() === CheckoutMode.REDIRECT;

/**
 * Whether the checkout owns the whole tab and must navigate back to the merchant
 * itself on success / failure / cancel, instead of posting `CLOSE_CHECKOUT` to an
 * SDK host that isn't there.
 *
 * True for Payment Links (a backend session subtype) and for any session the store
 * opened with `?mode=redirect` — behaviourally the two are the same flow.
 *
 * The URL read is a defaulted argument so callers that already know the answer —
 * chiefly tests — can inject it and keep this pure.
 */
export const resolveIsRedirectFlow = (
  checkoutConfiguration: CheckoutConfigurations | undefined,
  isRedirectMode = isRedirectModeRequested()
) => getCheckoutSolution(checkoutConfiguration).isPaymentLinks || isRedirectMode;
